/* eslint-disable quotes */
import { changeOrderTypeEndpoint } from '../../api/backend';
import { renderErrorMessage } from '../../utils';
import { showMessageModal, showOrderStatus } from '../../redux/actions';
import store from '../../redux/store';
import {
  MODIFY_ORDER_TYPE_PROMOTION,
  TEXT_CANCEL_ORDER
} from '../../constants';
import { logHighError } from '../../utils/logger';

export const changeOrderType = async (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  order: any,
  newOrderType: string,
  setLoadingChanginOrderType?: React.Dispatch<React.SetStateAction<boolean>>,
  refundReduction?: number,
) => {
  const handleError = (error: any) => {
    store.dispatch(showMessageModal(renderErrorMessage(error)));
    logHighError(`Error changing order type ${error}`);
  };

  const handleLoading = (loading: boolean) => {
    setIsLoading(loading);
    if (setLoadingChanginOrderType) setLoadingChanginOrderType(loading);
  };

  try {
    if (newOrderType === MODIFY_ORDER_TYPE_PROMOTION.REFUND) {
      const discountMessage =
        refundReduction && refundReduction > 0
          ? `Annulez sans frais et recevez aussitôt un code promo de ${refundReduction}% pour votre prochaine commande.`
          : `Vous ne pouvez pas vous déplacer ? Annulez votre commande en cliquant sur le bouton ci-dessous.`;

      store.dispatch(showMessageModal(TEXT_CANCEL_ORDER, {
        discountMessage,
        showCancel: true,
        onClick: async () => {
          setIsLoading(true);
          await changeOrderTypeEndpoint(order, newOrderType);
          store.dispatch(showOrderStatus(false));
          store.dispatch(
            showMessageModal(
              `Votre commande n°${order.orderNumber} a été annulée avec succès.`
            )
          );
        },
      }));
      return;
    }
    if (newOrderType === MODIFY_ORDER_TYPE_PROMOTION.CLICK_AND_COLLECT) {
      handleLoading(true);
      await changeOrderTypeEndpoint(order, newOrderType);
    }
  } catch (error) {
    handleError(error);
  } finally {
    handleLoading(false);
  }
};
